import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function ManagerPendingWidget({ pendingApprovals }) {
  const navigate = useNavigate();

  if (!pendingApprovals || pendingApprovals.totalPending === undefined) {
    return null;
  }

  const { pendingLeaves = 0, pendingRegularizations = 0, totalPending = 0 } = pendingApprovals;

  if (totalPending === 0) {
    return null;
  }

  return (
    <div className="rounded-3xl border border-amber-500/25 bg-amber-500/5 p-6 shadow-xs">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-amber-500/15 text-amber-700 shadow-inner">
            <span className="material-symbols-outlined text-2xl">pending_actions</span>
          </div>
          <div>
            <div className="inline-flex items-center gap-1.5 rounded-full bg-amber-500/20 px-2.5 py-0.5 text-[10px] font-bold text-amber-900 mb-1">
              <span>Manager Attention Required</span>
            </div>
            <h3 className="text-sm font-extrabold text-on-surface">
              {totalPending} Subordinate Request{totalPending > 1 ? 's' : ''} Pending Review
            </h3>
            <p className="text-xs text-slate-600 mt-0.5">
              Direct reportees have submitted requests awaiting your verification
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2 flex-wrap">
          {pendingLeaves > 0 && (
            <button
              type="button"
              onClick={() => navigate('/self-service/my-subordinates')}
              className="inline-flex items-center gap-1.5 rounded-xl border border-amber-500/30 bg-surface px-3 py-2 text-xs font-bold text-amber-800 shadow-xs hover:bg-amber-50 transition cursor-pointer"
            >
              <span className="material-symbols-outlined text-sm">event_busy</span>
              <span>{pendingLeaves} Leave{pendingLeaves > 1 ? 's' : ''}</span>
            </button>
          )}

          {pendingRegularizations > 0 && (
            <button
              type="button"
              onClick={() => navigate('/self-service/attendance-regularization')}
              className="inline-flex items-center gap-1.5 rounded-xl border border-amber-500/30 bg-surface px-3 py-2 text-xs font-bold text-amber-800 shadow-xs hover:bg-amber-50 transition cursor-pointer"
            >
              <span className="material-symbols-outlined text-sm">pending_actions</span>
              <span>{pendingRegularizations} Punch Reg.</span>
            </button>
          )}

          <button
            type="button"
            onClick={() => navigate('/self-service/my-subordinates')}
            className="inline-flex items-center gap-1 rounded-xl bg-amber-600 px-4 py-2 text-xs font-bold text-white shadow-xs hover:bg-amber-700 transition cursor-pointer"
          >
            <span>Review Subordinates</span>
            <span className="material-symbols-outlined text-sm">arrow_forward</span>
          </button>
        </div>
      </div>
    </div>
  );
}
